import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the SpeechtotextProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class SpeechtotextProvider {

  constructor(public http: Http) {
    console.log('Hello SpeechtotextProvider Provider');
  }
//todo Versuch ob sich sracherkennung als provider realisieren lässt
}



// WEBPACK FOOTER //
// ./src/providers/speechtotext/speechtotext.ts